<template>
    <!--
           作者：peng
           时间：2020-08-19
           描述：插件中心-客户信息-客户设置
       -->
    <div class="product-add pb50" v-loading="loading">
        <div>
            <div class="common-form">基础设置</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
                    <el-form-item label="是否开启客户资源功能" style="display: block;" :label-width="formLabelWidth">
                        <el-radio-group v-model="form.is_open" prop="is_bind">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否开启区域绑定" style="display: block;" :label-width="formLabelWidth">
                        <el-radio-group v-model="form.is_bind" prop="is_bind">
                            <el-radio :label="0" @change="kopen(1)">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="详情页拨打电话按钮" style="display: block;" :label-width="formLabelWidth">
                        <el-radio-group v-model="form.is_phone" prop="is_phone">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="详情页自动导航按钮" style="display: block;" :label-width="formLabelWidth">
                        <el-radio-group v-model="form.is_navigation" prop="is_navigation">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="每人最多绑定客户数量" style="display: block;" :label-width="formLabelWidth">
                        <el-input type="number" min="1" v-model="form.is_max" placeholder="请输入绑定个数"></el-input>
                    </el-form-item>
                    <el-form-item label="会员等级查看权限" style="display: block;" :label-width="formLabelWidth">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="(city,index) in cities" :label="city" :key="index">{{city}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item :label-width="formLabelWidth">
                        <el-button type="primary" @click="gotoTrue()">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomerApi from '@/api/customer.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '220px',
                /*是否加载完成*/
                loading: false,
                form:{
                    is_open:1,
                    is_bind:1,
                    is_phone:1,
                    is_navigation:1,
                    is_max:1
                },
                cities:[],
                cities_id:[],
                checkAll: false,
                /* 选中 */
                checkedCities: [],
                checkedCities_id: [],
                isIndeterminate: true
            };
        },
        created() {
            this.userList();
        },
        methods: {
            handleCheckAllChange(val){
                this.checkedCities = val ? this.cities : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            },
            /* 会员等级 */
            userList(){
                let self = this
                CustomerApi.user_list('',true)
                    .then(data => {
                        let list = data.data.list
                        list.forEach((item) => {
                            self.cities_id.push(item.grade_id)
                            self.cities.push(item.name)
                        })
                        self.getSetting();
                    })
                    .catch(error => {

                    });
            },



            getSetting(){
                let self = this
                self.checkedCities = [];
                self.checkedCities_id = [];
                CustomerApi.get_setting('',true)
                    .then(data => {
                        if (data.data.list != null){
                            self.form = data.data.list;
                            if (self.form.grade_id.sort().toString() == self.cities_id.sort().toString()){
                                self.checkAll = true
                                self.isIndeterminate = false
                            }
                            self.form.grade_id.forEach((item) => {
                                self.checkedCities.push(self.cities[self.cities_id.indexOf(item)]);
                             //   self.checkedCities_id.push(self.cities_id[self.cities_id.indexOf(item)]);
                            })
                        }
                    })
                    .catch(error => {

                    })
            },
            kopen(){
              let self = this
              self.form.is_bind = 0;
            },
            gotoTrue(){
                let self = this
                let params = {};
                params = self.form;
                if (params.is_max == '' || params.is_max < 1){
                    this.$message({
                        type: 'info',
                        message: '绑定客户数量必须大于1'
                    });
                    return false;
                }
                if (self.checkedCities.length > 0){
                    let grade_id = ''
                    self.checkedCities.forEach((item) => {
                        self.checkedCities_id.push(self.cities_id[self.cities.indexOf(item)])
                        grade_id = self.cities_id[self.cities.indexOf(item)] + ',' + grade_id
                    })
                    params.grade_id = grade_id
                }else {
                    this.$message({
                        type: 'info',
                        message: '至少选择一个会员等级'
                    });
                    return false;
                }
                CustomerApi.put_setting(params,true)
                    .then(data => {
                        this.$message({
                            type: 'success',
                            message: data.msg
                        });
                        self.getSetting()
                    })
                    .catch(error => {
                        this.$message({
                            type: 'info',
                            message: '保存失败'
                        });
                    });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/customer/setting/setting.vue